export { default } from "./ClientInfo";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/ClientInfo/index.js